
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transaction_bet_game",
      function () {
        return require("private-next-pages/transaction_bet_game.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transaction_bet_game"])
      });
    }
  